import FontPickerEditor from './FontPickerEditor';

export default FontPickerEditor;
